/**
 * This file is only need if you want to extract messages into JSON files in locales folder
 * AND if you are also using the object syntax instead of string syntax. \
 * Check the documentation section i18n for details
 */

import { translations } from 'locales/translations';
import { _t } from 'utils/messages';

export const messages = {
  active: () => _t(translations.dashboardTiles.active),
  closed: () => _t(translations.dashboardTiles.closed),
  expired: () => _t(translations.dashboardTiles.expired),
  sublimit: () => _t(translations.dashboardTiles.sublimit),
  upcomingRenewals: () => _t(translations.dashboardTiles.upcomingRenewals),
};
